export default "__VITE_ASSET__f5493007__"